import { useEffect } from 'react';

export const useMapViewAdjustment = ({ activeShop, shops, setDefaultXY, setZoom, region, isMobile, mapZoom }) => {
  useEffect(() => {
    if (activeShop && activeShop?.map) {
      setDefaultXY([activeShop?.map?.y, activeShop?.map?.x]);
      setZoom(15);
    } else {
      const filterShop = shops.filter(shop => shop?.map?.x && shop?.map?.y);
      if (filterShop.length > 0) {
        let x = 0;
        let y = 0;
        filterShop.forEach(item => {
          x += item.map.x;
          y += item.map.y;
        });
        const avgX = x / filterShop.length;
        const avgY = y / filterShop.length;

        const adjustedX = parseInt(region as string, 10) === 1 && !isMobile ? avgX + 0.5 : avgX;

        setDefaultXY([avgY, adjustedX]);
        setZoom(isMobile ? mapZoom - 1 : mapZoom);
      }
    }
  }, [activeShop]);
};
